/**
 * Application permission constants – derived from the ChemInfoRechte enum (backend).
 * Use these constants instead of magic numbers with *appHasRight / *appNotHasRight.
 *
 * Example:
 *   *appHasRight="[Rights.StoffErstellen]"
 *   *appHasRight="[Rights.ImporteVerwalten, Rights.ImportePruefen]"
 */
export const AppRights = {
  RedaktionLesen: 101,
  StoffErstellen: 103,
  Stoffdatenpflege: 104,
  StoffStrukturImport: 109,
  StoffdatenpflegeFachlektorFreigabe: 110,
  StoffdatenpflegeAdministratorFreigabe: 111,
  Stoffzusammenfuehrung: 120,
  StoffzusammenfuehrungFreigeben: 121,
  SachverhalteKopieren: 122,
  ZitatZusammenfuehrung: 123,
  ErfassungUebernehmen: 130,
  AlleFavoritenListenVerwalten: 150,
  ValidierungsregelkatalogLesen: 303,
  ValidierungsregelkatalogVerwalten: 304,
  ThesaurusregelkatalogVerwalten: 305,
  RankingLesen: 309,
  RankingVerwalten: 310,
  ThesaurusregelkatalogLesen: 312,
  PSatzRegeltabellenLesen: 401,
  PSatzRegeltabellenVerwalten: 402,
  SystemFeedbackBearbeiten: 601,
  StoffFeedbackBearbeiten: 602,
  ExporteVerwalten: 700,
  ExporteLesen: 701,
  SystemeinstellungenChemInfoAendern: 702,
  WartungsfensterLesen: 708,
  WartungsfensterVerwalten: 709,
  RedaktionelleNachschlagetabellenBearbeiten: 710,
  NachschlagetabellenwerteZusammenfuehren: 711,
  SpeziesVerwalten: 730,
  NutzerverwaltungLesen: 720,
  Datenmodellaenderung: 800,
  ImporteLesen: 900,
  ImporteVerwalten: 901,
  ImportePruefen: 902,
} as const;

export type AppRight = typeof AppRights[keyof typeof AppRights];
